<template>
	<menu-component :menuItems="menuItems" />
</template>
<script>
import MenuComponent from './Menu.vue'

export default {
	components: { MenuComponent },
  setup() {
    const { t } = useTranslation()
    const route = useRoute()

    return {
      t,
      route,
    }
  },
	data() {
		return {
			menuItems: [
				{
					path: `/co/${this.route.params.accountId}/instructions`,
					title: this.t('INSTRUCTIONS'),
					menu: 'main',
				},
				{
					path: `/co/${this.route.params.accountId}/felling`,
					title: this.t('FELLING'),
					menu: 'main',
				},
				{
					path: `/co/${this.route.params.accountId}/silviculture`,
					title: this.t('SILVICULTURE'),
					menu: 'main',
				},
			],
		}
	},
}
</script>
